module.exports = __webpack_public_path__ + "img/banner-kcp.730724cc.png";